import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { ActionsDefaultThemeSnippet, useTheme } from '@src/themes';
import { FC, forwardRef, PropsWithChildren, ReactNode } from 'react';
import { Header } from '../text';

const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction='left' ref={ref} {...props} />;
});

interface DrawerProps extends PropsWithChildren {
  actions?: ReactNode;
  handleClose?: (v: boolean) => void;
  opened: boolean;
  title?: ReactNode;
}

const Drawer: FC<DrawerProps> = ({ actions, children, handleClose, opened, title }) => {
  const { COLORS } = useTheme();

  return (
    <Dialog
      open={opened}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        handleClose?.(false);
      }}
      fullScreen
      TransitionComponent={Transition}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(0,0,0,0.4)' },
        },
      }}
      PaperProps={{
        sx: {
          maxWidth: 760,
          width: '100%',
          ml: 'auto',
          borderRadius: 0,
        },
      }}
    >
      <DialogTitle style={{ position: 'sticky' }}>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Header variant='h2' sx={{ fontWeight: 'bold' }} color={COLORS.text.primary}>
            {title}
          </Header>
          <IconButton component='span' onClick={() => handleClose?.(false)}>
            <CloseIcon sx={{ fontSize: { md: 24, xs: 20 }, color: COLORS.ctas.secondary }} />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', padding: 3 }}>
        <ActionsDefaultThemeSnippet>
          <Button variant='text' onClick={() => handleClose?.(false)}>
            Fechar
          </Button>
          <Box>{actions}</Box>
        </ActionsDefaultThemeSnippet>
      </DialogActions>
    </Dialog>
  );
};

export { Drawer };
